import { render, staticRenderFns } from "./bannerposition.vue?vue&type=template&id=67f4f587&"
import script from "./bannerposition.vue?vue&type=script&lang=js&"
export * from "./bannerposition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports